let inactivityTimer;

// Function to start the inactivity timer
const startInactivityTimer = () => {
  // Clear existing timer if any
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }

  // Set a new timer for 25 minutes (25 * 60 * 1000 milliseconds)
  inactivityTimer = setTimeout(() => {
    // Clear localStorage and redirect to login page
    localStorage.clear();
    window.location.href = "/"; // Redirect to login page
  }, 25 * 60 * 1000); // 25 minutes
};

// Function to reset the inactivity timer on user activity
const resetInactivityTimer = () => {
  startInactivityTimer();
};

// Add event listeners to track user activity
const setupInactivityTracker = () => {
  // Events to track user activity
  const events = ["mousemove", "keydown", "click", "scroll"];

  // Attach event listeners
  events.forEach((event) => {
    window.addEventListener(event, resetInactivityTimer);
  });

  // Start the timer initially
  startInactivityTimer();
};

export default setupInactivityTracker;